import cn from "classnames";
import * as React from "react";
import { allPagesFlattened } from "~/routing/pageRegistrations/allPageRegistrations";
import { TopicsContainer } from "./Registrations/CommonComponents/CommonViews";
import { DefaultOverview } from "./Registrations/CommonComponents/DefaultViews";
interface PageHelpViewProps {
    className?: string;
    pageId: string | undefined;
}
export const PageHelpOverviewView: React.FC<PageHelpViewProps> = ({ pageId, className }) => {
    const registration = usePageHelpRegistrationsForPage(pageId);
    const helpContent = registration?.helpContent?.();
    if (!registration || !helpContent) {
        return <DefaultOverview />;
    }
    return <div className={cn(className)}>{helpContent}</div>;
};
PageHelpOverviewView.displayName = "PageHelpOverviewView"
export const PageHelpTopicsView: React.FC<PageHelpViewProps> = ({ pageId, className }) => {
    const registration = usePageHelpRegistrationsForPage(pageId);
    const helpTopics = registration?.helpTopics?.();
    if (!registration || !helpTopics) {
        return <TopicsContainer />;
    }
    return <div className={cn(className)}>{helpTopics}</div>;
};
PageHelpTopicsView.displayName = "PageHelpTopicsView"
function usePageHelpRegistrationsForPage(pageId: string | undefined) {
    return React.useMemo(() => allPagesFlattened.find((pageRegistration) => pageId === pageRegistration.pageId), [pageId]);
}
